import { AppAreaConfig } from '@/funnels/@types'
import taiChiWalkingV2Al from './activity-female-tai-chi-walking-v2-al'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-chair-tai-chi-al-fwf',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-chair-tai-chi-f', 'age-chair-tai-chi-f'],
		route: {
			path: '/chair-tai-chi-f-al-fwf',
			name: 'female-chair-tai-chi-al-fwf-funnel',
		},
	},
	funnel: {
		id: 'ob-female-tai-chi-chair-al-fwf',
		route: {
			path: '/chair-tai-chi-f-al-fwf/ob/:page(.*)?',
			name: 'activity-female-chair-tai-chi-al-fwf',
		},
		slug: 'activity-female-chair-tai-chi-al-fwf',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: taiChiWalkingV2Al,
				page: 'focus-area',
			},
		},
	},
}

export default appAreaConfig
